var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2TicketsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.556 5.333h8.888v5.334H3.556V5.333zM14.666 8c0 .736.598 1.333 1.334 1.333V12c0 .736-.597 1.333-1.333 1.333H1.333A1.333 1.333 0 010 12V9.333a1.333 1.333 0 100-2.666V4c0-.736.597-1.333 1.333-1.333h13.334C15.403 2.667 16 3.264 16 4v2.667c-.736 0-1.333.597-1.333 1.333zm-1.333-2.889a.667.667 0 00-.666-.667H3.333a.667.667 0 00-.666.667v5.778c0 .368.298.667.666.667h9.334a.667.667 0 00.666-.667V5.11z",
    fill: "#9FA2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2TicketsSvg);
export default __webpack_public_path__ + "static/media/_2TicketsSvg.73cd435084e6b1ab39a882e996acbe70.svg";
export { ForwardRef as ReactComponent };